import React from "react";
import { useHistory } from "react-router-dom";
import { Crown, ChevronRight } from "lucide-react";
import styles from "./FeedSpotlightCard.module.css";
import { CreatorSpotlightItem } from "./dummyFeedData";

interface FeedSpotlightCardProps {
  item: CreatorSpotlightItem;
}

export default function FeedSpotlightCard({ item }: FeedSpotlightCardProps) {
  const history = useHistory();

  return (
    <div className={styles.spotlightCard}>
      <h3 className={styles.heading}>{item.title}</h3>

      {/* Creator Avatar & Name */}
      <div
        className={styles.creatorHeader}
        onClick={() => history.push(`/${item.creator.username}`)}
      >
        <div className={styles.avatarRing}>
          <img
            src={item.creator.avatar}
            alt={item.creator.name}
            className={styles.avatarImg}
          />
        </div>
        <h4 className={styles.creatorName}>{item.creator.name}</h4>
        <span className={styles.creatorHandle}>@{item.creator.username}</span>
      </div>

      {/* 3 Showcase Photos / Locked Teaser */}
      <div className={styles.galleryGrid}>
        {item.galleryPreviews.map((preview, index) => {
          if (preview.isLocked) {
            return (
              <div
                key={preview.id}
                className={`${styles.galleryItem} ${styles.lockedGalleryItem}`}
                onClick={() => history.push(`/${item.creator.username}`)}
              >
                <img
                  src={preview.url}
                  alt="Exclusive teaser"
                  className={styles.galleryImg}
                />
                <div className={styles.lockedBlurOverlay}>
                  <Crown size={22} className={styles.crownIcon} />
                  <span className={styles.lockTitle}>
                    {preview.lockTitle || "Subscribe to Unlock"}
                  </span>
                  <span className={styles.lockSubtitle}>
                    {preview.lockSubtitle || "all exclusive content"}
                  </span>
                </div>
              </div>
            );
          }

          return (
            <div
              key={preview.id}
              className={styles.galleryItem}
              onClick={() => history.push(`/${item.creator.username}`)}
            >
              <img
                src={preview.url}
                alt="Showcase"
                className={styles.galleryImg}
              />
              {index === item.galleryPreviews.length - 1 && (
                <button
                  className={styles.nextNavBtn}
                  aria-label="Next preview"
                  onClick={(e) => {
                    e.stopPropagation();
                    history.push(`/${item.creator.username}`);
                  }}
                >
                  <ChevronRight size={18} />
                </button>
              )}
            </div>
          );
        })}
      </div>

      {/* View Profile CTA */}
      <button
        className={styles.viewProfileBtn}
        onClick={() => history.push(`/${item.creator.username}`)}
      >
        View Profile
      </button>
    </div>
  );
}
